import { render, staticRenderFns } from "./InterestSettings.vue?vue&type=template&id=79de6032"
import script from "./InterestSettings.vue?vue&type=script&lang=ts"
export * from "./InterestSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports